<template>
  <div class="risk-level-container">
    <div
      v-for="level in COLORS.length"
      :key="level"
      class="risk-level"
      :style="{background: COLORS[level - 1]}"
      @click="$emit('click:level', level - 1)"
    >
      <div
        v-if="value === level - 1"
        class="value"
        :style="{background: COLORS[level - 1]}"
        @click.stop="$emit('click:value', value)"
      >
        {{ level - 1 }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ZRiskLevel',
  props: {
    value: {
      type: Number,
      default: 0,
    },
  },

  data() {
    return {
      COLORS: [
        '#1ABA00',
        '#2AD026',
        '#5EF218',
        '#B9F218',
        '#EEF218',
        '#F2DC18',
        '#F2C218',
        '#F2B518',
        '#F29B18',
        '#EA5F11',
        '#EA1111',
      ],
    }
  },
}
</script>

<style scoped lang="scss">
.risk-level-container {
  display: flex;
  align-items: center;
  width: 100%;
  height: 9px;
  background: white;

  .risk-level {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 1;
    height: 100%;

    &:first-child {
      border-radius: 5px 0 0 5px;
    }

    &:last-child {
      border-radius: 0 5px 5px 0;
    }

    .value {
      user-select: none;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 13px;
      font-weight: bold;
      color: var(--black);
      border-radius: 50%;
      padding: 13px;
      height: 20px;
      width: 20px;
    }
  }
}
</style>
